import styles from "../../styles/PLMApp.module.css";
// src/components/plm/UploadPanel.jsx

import { useState, useRef } from "react";

import { DOC_TAGS } from "../../data/constants";
import { uploadDocument, saveStep } from "../../firebase/firebaseHelpers";

export default function UploadPanel({
  stepId,
  categoryId,
  supplierId,
  orderId,
  isAdmin,
  currentStatus,
  onStatusChange,
}) {
  const [dragging, setDragging] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [tag, setTag] = useState("Other");
  const [toast, setToast] = useState(null);
  const inputRef = useRef();

  const handleFiles = async (files) => {
    if (!files?.length || !supplierId || !orderId) return;

    setUploading(true);
    setProgress(0);

    const file = files[0];

    try {
      await uploadDocument(supplierId, orderId, file, stepId, categoryId, tag);

      const shouldSetWaiting =
        !isAdmin && currentStatus !== "done" && currentStatus !== "not_needed";

      if (shouldSetWaiting) {
        await saveStep(supplierId, orderId, stepId, { status: "waiting" });
        onStatusChange?.("waiting");
      }

      setUploading(false);
      setProgress(100);
      setToast("File uploaded successfully");
      setTimeout(() => {
        setToast(null);
        setProgress(0);
      }, 2500);
    } catch (err) {
      console.error(err);
      setUploading(false);
      setProgress(0);
    }
  };

  return (
    <>
      <div className={styles.drawerSection}>
        <div className={styles.drawerSectionTitle}>FILE CATEGORY</div>
        <select
          className={styles.fieldSelect}
          value={tag}
          onChange={(e) => setTag(e.target.value)}
          style={{ marginBottom: 10 }}
        >
          {DOC_TAGS.filter((t) => t !== "All").map((t) => (
            <option key={t} value={t}>
              {t}
            </option>
          ))}
        </select>
      </div>

      <div
        className={`${styles.uploadZone} ${
          dragging ? styles.uploadZoneActive : ""
        }`}
        onDragOver={(e) => {
          e.preventDefault();
          setDragging(true);
        }}
        onDragLeave={() => setDragging(false)}
        onDrop={(e) => {
          e.preventDefault();
          setDragging(false);
          handleFiles(e.dataTransfer.files);
        }}
        onClick={() => inputRef.current?.click()}
      >
        <div className={styles.uploadIcon}>📎</div>
        <div className={styles.uploadLabel}>Drop file or click to browse</div>
        <div className={styles.uploadSub}>
          Tech Pack, Lab Test, QC Report, PO, etc.
        </div>
        <input
          ref={inputRef}
          type="file"
          style={{ display: "none" }}
          onChange={(e) => handleFiles(e.target.files)}
        />
      </div>

      {uploading && (
        <div className={styles.uploadProgress}>
          <div className={styles.uploadProgressBar}>
            <div
              className={styles.uploadProgressFill}
              style={{ width: `${progress}%` }}
            />
          </div>
          <span className={styles.uploadProgressText}>{progress}%</span>
        </div>
      )}

      {toast && (
        <div className={styles.toast}>
          <div className={styles.toastDot} />
          {toast}
        </div>
      )}
    </>
  );
}
